export default {
    PROPANE: 'propane',
    OIL: 'oil',
    GAS: 'gas',
    ELECTRIC: 'electric',
};
